import script from "./GuesserAdminView.vue?vue&type=script&lang=ts&setup=true"
export * from "./GuesserAdminView.vue?vue&type=script&lang=ts&setup=true"

import "./GuesserAdminView.vue?vue&type=style&index=0&id=45fbe25c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45fbe25c"]])

export default __exports__